import { forwardRef, useImperativeHandle } from 'react';

import { useGetIntegrationSettingsQuery } from '@xemplo/business-unit-query';
import { CenteredLoaderDots } from '@xemplo/loader';
import { Modal, useModalDialog } from '@xemplo/modal-dialog';
import { useGetPayrunByIdQuery } from '@xemplo/payrun-query';

import { FinalisePayrunModalProps, ModalDialogRef } from '../finalise-payrun.types';

import { FinalisePayrunContent } from './finalise-payrun-content';

export const FinalisePayrunModal = forwardRef<ModalDialogRef, FinalisePayrunModalProps>(
  (props, ref) => {
    const { payrunId, onSuccess } = props;
    const modalDialog = useModalDialog({ id: 'finalise-payrun-modal' });
    useImperativeHandle(ref, () => modalDialog, [modalDialog]);

    // Resolve the pay run first — its business unit drives the integration-settings fetch.
    const { data: payrun, isLoading: isPayrunLoading } = useGetPayrunByIdQuery({
      id: payrunId,
    });
    const businessUnitId = payrun?.result?.businessUnitId;
    const { data: settingsData, isLoading: isSettingsLoading } =
      useGetIntegrationSettingsQuery({ businessUnitId });

    // Ensure all data is fully loaded before initialising the form.
    if (isPayrunLoading || (businessUnitId && isSettingsLoading)) {
      return <CenteredLoaderDots />;
    }
    if (!payrun?.result) return null;

    return (
      <Modal.Dialog {...modalDialog.dialogProps}>
        {modalDialog.isOpen && (
          <FinalisePayrunContent
            modalDialog={modalDialog}
            payrunId={payrunId}
            payrun={payrun.result}
            settings={settingsData?.settings ?? {}}
            onSuccess={onSuccess}
          />
        )}
      </Modal.Dialog>
    );
  },
);
